import React from 'react';
import { useRouter } from 'next/router';
import { UserTypeEnum } from '../../models';
import { roles, rolesTranslate } from '../../static';
import meitBoxesImg from '../../public/images/meit-boxes.png';
import meitLogoImg from '../../public/logos/logo-white.png';

interface UnLoggedLayoutProps {
  children: React.ReactNode;
  userType: UserTypeEnum;
}
function UnLoggedLayout({ children, userType }: UnLoggedLayoutProps) {
  const router = useRouter();
  const bgColor = userType === roles.admin ? 'bg-gray-300' : 'bg-purple-300';

  return (
    <main
      className={`relative min-h-screen w-full bg-login-allies-companies flex ${bgColor}`}
    >
      {/* form */}
      <section className="relative z-20 w-full lg:w-1/2 mx-auto flex flex-col items-center justify-center my-5 ">
        {/* meit logo */}
        <div className="flex justify-center relative ">
          <img className="w-44 sm:w-56" src={meitLogoImg.src} alt="logo" />
          <span
            className={` absolute text-xs sm:text-base bottom-0 uppercase mt-auto pb-[0.8rem] ${
              userType === roles.admin
                ? 'text-neutral-warm-500 -right-24 md:-right-32'
                : 'text-purple-100 -right-20'
            }`}
          >
            {rolesTranslate[userType]}
          </span>
        </div>
        {/* card */}
        <div
          className={`mx-10 ${
            router.pathname.includes('sign-in') ? 'max-w-lg' : 'max-w-xl'
          }  bg-system-100 flex flex-col rounded-lg p-5 sm:p-10 space-y-6`}
        >
          {children}
        </div>
        <div className="w-full text-center mt-5">
          <span className="text-text-white ">
            © Meit!, 2022 | Powered by Avila Tek
          </span>
        </div>
      </section>
      {/* bg boxes */}
      <div className="absolute w-full h-[70vh] bottom-0 overflow-hidden flex">
        <img
          className="relative w-full h-full object-cover object-top mt-auto"
          src={meitBoxesImg.src}
          alt="meit-bg"
        />
      </div>
    </main>
  );
}

export default UnLoggedLayout;
